/**
 * Circle–circle collision helpers (pixels, same space as sprites).
 */

export function distanceSq(ax, ay, bx, by) {
  const dx = ax - bx;
  const dy = ay - by;
  return dx * dx + dy * dy;
}

export function circlesOverlap(ax, ay, ar, bx, by, br) {
  const r = ar + br;
  return distanceSq(ax, ay, bx, by) <= r * r;
}

export function clearanceFromPlayer(px, py, pr, sx, sy, sr, minDist) {
  const d = Math.sqrt(distanceSq(px, py, sx, sy)) - (pr + sr);
  return d >= minDist;
}
